"use strict";
/**
 * Market Selection Modal Handler
 *
 * Manages the market-selection modal on the order page:
 * - Open (via the market-selection button)
 * - Close / overlay-dismiss / Done button
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupMarketSelectionModal = setupMarketSelectionModal;
const ui_1 = require("../../ui");
/**
 * Wire up all event listeners for the market-selection modal.
 * Called once from `initApp`.
 */
function setupMarketSelectionModal() {
    const openBtn = document.getElementById("market-selection-btn");
    const closeBtn = document.getElementById("close-market-selection-modal");
    const doneBtn = document.getElementById("close-market-selection-btn");
    const overlay = document.querySelector(".market-selection-modal-overlay");
    if (openBtn) {
        openBtn.addEventListener("click", () => (0, ui_1.showMarketSelectionModal)());
    }
    if (closeBtn) {
        closeBtn.addEventListener("click", () => (0, ui_1.hideMarketSelectionModal)());
    }
    if (doneBtn) {
        doneBtn.addEventListener("click", () => (0, ui_1.hideMarketSelectionModal)());
    }
    if (overlay) {
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay)
                (0, ui_1.hideMarketSelectionModal)();
        });
    }
}
